import { useBootstrapConfiguration } from "~/app/config/useAppConfig";

export enum WebcomponentToggle {
  MOUNTING_MANAGER = "mountingManager",
  GREASE_APP = "greaseApp",
  EASY_CALC = "easyCalc",
}

export function useIsWebComponentEnabled(webcomponentToggle: WebcomponentToggle) {
  return useBootstrapConfiguration()?.webComponentEnabledTabs?.includes(webcomponentToggle) ?? false;
}
